import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { SeErrorStateMatcher } from '../../../utils/error-state-matcher';

@Component({
    selector: 'se-alphanumeric-cell-editor-base',
    template: ''
})
export class AlphanumericCellEditorBaseComponent implements OnInit {
    /**
     * Current value of the cell
     * ngModel setted by AlphanumericCellEditorComponent
     */
    @Input() value: string;

    /**
     * (Optional) it allows to specify as array of char any not admissible chars.
     * passed by AlphanumericCellEditorComponent
    */
    @Input() notAdmissibleChars: Array<string>;

    /**
     *  (Optional) it allows to specify if the filed is mandatory
     */
    @Input() required: boolean;

    /**
     * Event emitted when the reactive form is ready
     */
    @Output() formReady: EventEmitter<FormControl> = new EventEmitter<FormControl>();

    /**
     * ElementRef of the input field
     */
    @ViewChild('alphanumericInput', { static: false, read: ElementRef }) alphanumericInput: ElementRef;

    notAdmissibleCharsString: string;
    notAdmissibleCharsRegexp: RegExp;

    formControl: FormControl;
    matcher = new SeErrorStateMatcher();

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        if (this.notAdmissibleCharsRegexp) {
            return !this.notAdmissibleCharsRegexp.test(event.key);
        }
        return true;
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        this.validateFields(event);
    }

    constructor () {
        // empty
    }

    ngOnInit(): void {
        this.configPatternForAvailableChars();
        const validators: Array<ValidatorFn> = [];
        this.formControl = new FormControl(this.value, []);
        if (this.required) {
            validators.push(Validators.required);
        }

        this.formControl.setValidators(validators);


    }

    private configPatternForAvailableChars() {
        // regExp for not admissible chars
        if (this.notAdmissibleChars) {
            this.notAdmissibleCharsString = '[' + this.notAdmissibleChars.join('') + ']';
            this.notAdmissibleCharsRegexp = new RegExp(this.notAdmissibleCharsString);
        }
    }

    private validateFields(event) {
        setTimeout(() => {
            let notAdmissibleRegExp: RegExp;
            if (this.notAdmissibleChars) {
                notAdmissibleRegExp = new RegExp('[' + this.notAdmissibleChars.join() + ']', 'g');
            }
            this.alphanumericInput.nativeElement.value = this.alphanumericInput.nativeElement.value
                .replace(notAdmissibleRegExp, '')
                .replace(/\s/g, '');

            event.preventDefault();
        }, 100);
    }
}
